'use client'

import Image from 'next/image'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/src/components/ui/dialog'
import { Button } from './button'

interface InfoDialogProps {
  isOpen: boolean
  onClose: () => void
  onClickCta?: () => void
  heroImgUrl?: string
  title: string
  descriptions: (string | React.ReactNode)[]
  ctaText?: string
}

export const InfoDialog = ({
  isOpen,
  onClose,
  onClickCta,
  heroImgUrl,
  title,
  descriptions,
  ctaText,
}: InfoDialogProps) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent
      aria-describedby='setup accounts'
      className='max-w-md'
      showCloseButton={true}
      showBackButton={false}
      headerClassName='absolute top-0 left-0 right-0 dark'
    >
      <div className='p-8 pb-28 h-full overflow-y-auto no-scrollbar'>
        <div className='-m-8 mb-8 max-h-64 flex items-center overflow-hidden'>
          <Image
            src={heroImgUrl ?? '/assets/artworks/pioneer-glass-bridge.png'}
            alt='Pioneer on a glass bridge'
            width={448}
            height={252}
          />
        </div>

        <DialogHeader className='mb-8'>
          <DialogTitle className='text-4xl text-left font-serif font-extralight'>
            {title}
          </DialogTitle>
        </DialogHeader>

        <div className='space-y-5'>
          {descriptions.map((description, index) => (
            <DialogDescription key={index} className='text-left'>
              {description}
            </DialogDescription>
          ))}
        </div>
      </div>

      <div className='absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-b from-transparent to-foreground to-50%'>
        <Button
          variant='secondary'
          size='lg'
          className='w-full backdrop-blur-xl'
          onClick={() => {
            if (onClickCta) {
              return onClickCta()
            }
            onClose()
          }}
        >
          {ctaText ?? 'Got it'}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
)
